import React from 'react'
import styled from 'styled-components'

const Footnotes = ({ children }) => {
	const content = children.map((el, i) => {
		const n = i + 1
		return (
			<li key={n} id={`footnote-${n}`}>
				{el}
				<span>
					<a href={`#link-footnote-${n}`}>Return</a> ↑
				</span>
			</li>
		)
	})
	return <List>{content}</List>
}

const List = styled.ol`
	margin: 3rem 0 0 0;
	padding: 2rem 0;
	padding-left: 1rem;
	font-size: 0.8rem;
	line-height: 1.5;
	border-top: 1px solid #eee;

	& li {
		&:not(:last-child) {
			margin-bottom: 1rem;
		}
		&:target {
			background: rgba(110, 0, 255, 0.1);
		}
	}

	& span {
		margin-left: 0.5rem;
		opacity: 0.6;
	}
`

const Super = ({ n }) => {
	return (
		<sup>
			<a href={`#footnote-${n}`} id={`link-footnote-${n}`}>
				{n}
			</a>
		</sup>
	)
}

export { Super, Footnotes }
